import { Component, Input } from '@angular/core';
import { LLCTransaction } from '@models/llc-mortgages';
import {
	MatterMortgage,
	MatterMortgagePriority,
	TransactionType,
} from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

@Component({
	selector: 'app-llc-mortgage-details',
	templateUrl: './mortgage-details.component.html',
	standalone: false,
})
export class LLCMortgageDetailsComponent {
	public priorityTypes = MatterMortgagePriority;
	public transactionTypes = TransactionType;

	@Input() mortgage: LLCTransaction;
	@Input() matterMortgage: MatterMortgage;

	constructor(private matterMortgageDispatch: MatterMortgageDispatch) {}

	updateLenderCollects(value) {
		this.matterMortgageDispatch.setLenderCollectsPropertyTaxes(
			this.matterMortgage.id,
			value,
		);
	}

	setStandardChargeTerm(value: string) {
		this.matterMortgageDispatch.updateMortgage(this.matterMortgage.id, {
			standardChargeTerm: value,
		});
	}
}
